import Component from "@glimmer/component"
import styles from "./body.module.css"

export default class PlannerCardStacksCardsPartsBodyComponent extends Component {
  readonly styles = styles
}
